import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import MediaManager from "../components/MediaManagerLayer";


const MediaManagerPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Media" />

        {/* DashBoardLayerTwo */}
        <MediaManager />

      </MasterLayout>
    </>
  );
};

export default MediaManagerPage;
